import {
  AUTHORIZE_SALESFORCE,
  DELETE_SALESFORCE,
  VERIFY_GSHEETS,
  VERIFY_SALESFORCE
} from '@dtx-company/flow-codegen/src/page/mutations'
import {
  AuthorizeSalesforceIntegrationMutation,
  AuthorizeSalesforceIntegrationMutationVariables,
  DeleteSalesforceIntegrationMutation,
  DeleteSalesforceIntegrationMutationVariables,
  VerifyGoogleSheetsIntegrationMutation,
  VerifyGoogleSheetsIntegrationMutationVariables,
  VerifySalesforceIntegrationMutation,
  VerifySalesforceIntegrationMutationVariables
} from '@dtx-company/flow-codegen/src/page/generated.types'
import { flowpageApi } from './empty'

export const crm = flowpageApi.injectEndpoints({
  endpoints: builder => ({
    deleteSalesforce: builder.mutation<
      DeleteSalesforceIntegrationMutation,
      DeleteSalesforceIntegrationMutationVariables
    >({
      query: () => ({
        document: DELETE_SALESFORCE,
        authOnly: true
      }),
      invalidatesTags: ['accountInfo']
    }),
    authorizeSalesforce: builder.mutation<
      AuthorizeSalesforceIntegrationMutation,
      AuthorizeSalesforceIntegrationMutationVariables
    >({
      query: ({ domain }) => ({
        document: AUTHORIZE_SALESFORCE,
        variables: {
          domain
        },
        authOnly: true
      }),
      invalidatesTags: ['accountInfo']
    }),

    verifySalesforce: builder.mutation<
      VerifySalesforceIntegrationMutation,
      VerifySalesforceIntegrationMutationVariables
    >({
      query: ({ code }) => ({
        document: VERIFY_SALESFORCE,
        variables: {
          code
        },
        authOnly: true
      }),
      invalidatesTags: ['accountInfo']
    }),
    verifyGoogleSheets: builder.mutation<
      VerifyGoogleSheetsIntegrationMutation,
      VerifyGoogleSheetsIntegrationMutationVariables
    >({
      query: ({ code }) => ({
        document: VERIFY_GSHEETS,
        variables: {
          code
        },
        authOnly: true
      }),
      invalidatesTags: ['accountInfo']
    })
  }),

  overrideExisting: true
})

export const {
  useAuthorizeSalesforceMutation,
  useVerifyGoogleSheetsMutation,
  useVerifySalesforceMutation,
  useDeleteSalesforceMutation
} = crm
